export enum EAmplitudeFeatureFlag {
  PLANS_REVERSED_ORDER = 'plans-reversed-order',
}

export enum EAmplitudeFeatureFlagValues {
  /**
   * on/off is default ones
   */
  OFF = 'off',
  ON = 'on',
}
